/* Zeryon: comparsa allo scroll, numeri che salgono, header che si compatta. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = ['.zy-hero__text > *', '.zy-stage', '.zy-sec__head', '.zy-cat', '.zy-card', '.zy-rev', '.zy-faq details', '.zy-cmp', '.zy-bundle .zy-wrap', '.zy-final .zy-wrap', '.zy-cross__card', '.zy-pdp__media', '.zy-pdp__buy > *', '.zy-trust__item'].join(',');
  var nodes = document.querySelectorAll(SEL);
  if (reduce || !('IntersectionObserver' in window)) {
    nodes.forEach(function (n) { n.classList.add('is-in'); });
  } else {
    var groups = {};
    nodes.forEach(function (n) {
      n.classList.add('zy-reveal');
      var parent = n.parentElement;
      var key = parent ? (parent.dataset.zyGroup || (parent.dataset.zyGroup = Math.random().toString(36).slice(2))) : 'x';
      groups[key] = (groups[key] || 0) + 1;
      n.style.setProperty('--zy-i', Math.min(groups[key] - 1, 8));
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^(-?)([\d.,]+)(.*)$/);
    if (!m) return;
    var sign = m[1], numStr = m[2], suffix = m[3];
    var decimal = numStr.indexOf(',') > -1 ? ',' : (numStr.indexOf('.') > -1 ? '.' : '');
    var target = parseFloat(numStr.replace(',', '.'));
    if (isNaN(target)) return;
    var decimals = decimal ? (numStr.split(decimal)[1] || '').length : 0;
    var start = null, dur = 1100;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      var v = (target * eased).toFixed(decimals).replace('.', decimal || '.');
      el.textContent = sign + v + suffix;
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }
  var stats = document.querySelectorAll('.zy-stat__num');
  if (stats.length && !reduce && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); so.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    stats.forEach(function (s) { so.observe(s); });
  }

  var header = document.getElementById('ZyHeader');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
